export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        templates: action.templates,
      };

    case 'DELETE':
      return {
        ...state,
        templates: state.templates.filter((item) => item.id !== action.templateId),
      };

    case 'CLONE':
      return {
        ...state,
        templates: [...state.templates, action.template],
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
